export enum TimeEntriesFilterType {
	ALL = 'ALL',
	UNASSIGNED = 'UNASSIGNED',
}
